import { MassOrderClient } from '../redux/reducers/clients'

// FIX ID je od 7/2026 atribut portfolia (s fallbackem na klienta) — viz FixService.resolveFixClientId
export const hasFixClientId = (client: MassOrderClient) =>
  !!(client.selectedPortfolio?.clientExternalId || client.clientExternalId)

export const hasFixPortfolioId = (client: MassOrderClient) => !!client.selectedPortfolio?.externalId
